import React, { useContext, useEffect, useState } from 'react'
import ProfileNav from './profile-nav'
import { Button, useMediaQuery } from '@mui/material'
import Profile_pic from './images/profile-avatar.png'

import CountryContext from './country_context'
import moment from 'moment'
import { BeatLoader, SyncLoader } from 'react-spinners'
import { ProfileNavSidePane } from './profile-nav-side-pane'
import { ProfileNavMobile } from './profile-nav-mobile'
import { ProfileWrapper } from './profile-wrapper'

export const ProfileAccount = () => {
    const [mobileView, setMobileView] = useState(false)
    const matches = useMediaQuery('(max-width:600px)');

    useEffect(() => {
        if (matches) {
            setMobileView(true)
        }
        else {
            setMobileView(false)
        }

    }, [matches])

    const context = useContext(CountryContext)
    return (
        <ProfileWrapper>
            <div className='row align-items-center 
                            
                            justify-content-center py-5'>
                <div className='col-md-4  '>

                    {context.user_sql_details && context.user_sql_details.public_id ?
                        <img src={`https://res.cloudinary.com/daurieb51/image/upload/${context.user_sql_details.public_id}.png`}
                            className='img-fluid profile-account-image brand-yellow-border brand-yellow-box-shadow p-2'
                            style={{ borderRadius: "50%" }} />
                        :
                        <img src={Profile_pic}
                            className='img-fluid profile-account-image brand-yellow-border brand-yellow-box-shadow'
                            style={{ borderRadius: "50%" }} />
                    }


                </div>


                <div className='col-md-5 align-items-start mt-5 mt-sm-0 px-sm-5 '>
                    {
                        context.user_sql_details ?
                            <div className='px-3 text-left '>
                                <p className=''><span className='brand-yellow-font '>Name:</span> <span className=''>{context.user_sql_details.username}</span></p>
                                <p className=''><span className='brand-yellow-font'>Email:</span> {context.user_sql_details.email}</p>
                                <p className=''><span className='brand-yellow-font'>Telephone Number: </span>{context.user_sql_details.phone_number}</p>
                                <p className=''><span className='brand-yellow-font'>Nationality:</span> N/A</p>
                                <p className=''><span className='brand-yellow-font'>Gender:</span> N/A</p>

                                <p className=''><span className='brand-yellow-font'>Address:</span>{context.user_sql_details.address}</p>
                                <p className=''><span className='brand-yellow-font'>
                                    Date registered:</span> {moment(context.user && context.user.metadata.creationTime).fromNow()}
                                </p>

                            </div>
                            :

                            <SyncLoader />
                    }


                </div>


            </div>
            <div className='row align-items-center justify-content-center mt-5'>
                <div className='col-md-3   text-uppercase text-left mt-3 mt-md-0'>
                    <div className='row justify-content-center justify-content-md-start'>
                        <p className='brand-yellow-border-bottom'> Edit Details</p>
                    </div>
                    <div className='row  justify-content-center justify-content-md-start'>
                        <p className='brand-yellow-border-bottom'> Reset Password</p>
                    </div>
                </div >
            </div>

        </ProfileWrapper >
    )
}